import { useContext } from "react"

import { Box } from "@mui/material"
import { Avatar } from "@unicity/design-system";
import { formatDateByLocale } from "../../common/date-functions";
import { LanguageContext } from "../../hooks/LanguageContext";
import { T } from "../../hooks/useTranslate";

const ReferralTableCellLeft = ({ referral }) => {
  const { currentLanguage } = useContext(LanguageContext);
  const currentLocale = currentLanguage.split("-")[0];

  return (
    <Box sx={{
      display: "inline-flex",
      gap: "8px",
      lineHeight: "normal"
    }}>
      <Box sx={{
        display: "flex",
        alignItems: "center"
      }}>
        <Avatar
          alt={referral.name}
          src={referral.avatar?.sizes[1]?.media}
          sx={{ width: 25, height: 25 }}
        />
      </Box>
      <Box>
        <Box sx={{ fontWeight: "600", fontSize: "calc(12px * var(--unicity-font-scale, 1))" }}>
          {referral.name}
        </Box>
        <Box sx={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))", opacity: ".6" }}>
          <T>date_joined</T>:
          {` ${formatDateByLocale(currentLocale, referral.joinDate)}`}
        </Box>
      </Box>
    </Box>
  )
}

export default ReferralTableCellLeft